import { useEffect } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { ConfigurationGroupType } from 'shared-types/SpaPackage';

import { SpaPackageFormValues } from '../../SpaPackageForm.schema';
import { isForcedConfigGroup } from '../SpaDayBooking.helpers';

type UseSeedForcedSelectionsParams = {
  form: UseFormReturn<SpaPackageFormValues>;
  configGroupsNoExtras: ConfigurationGroupType[];
  watchedGuests: SpaPackageFormValues['guests'] | undefined;
};

export function useSeedForcedSelections({
  form,
  configGroupsNoExtras,
  watchedGuests,
}: UseSeedForcedSelectionsParams) {
  useEffect(() => {
    const forcedGroups = configGroupsNoExtras.filter(
      (cg) => cg.isRequired && isForcedConfigGroup(cg)
    );
    if (forcedGroups.length === 0) return;

    const currentGuests = form.getValues('guests') || [];
    if (currentGuests.length === 0) return;

    let changed = false;

    const nextGuests = currentGuests.map((guest) => {
      const configGroups = { ...(guest.configurationGroups || {}) };
      let guestChanged = false;

      forcedGroups.forEach((group) => {
        const groupKey = `group_${group.id}`;
        const existing = configGroups[groupKey];
        const alreadySeeded =
          Array.isArray(existing) &&
          existing.length === group.options.length &&
          existing.every((entry) => entry?.isSelected);

        if (alreadySeeded) return;

        configGroups[groupKey] = group.options.map((opt, idx) => ({
          configurationGroupId: group.id,
          optionId: opt.id,
          isSelected: true,
          timeslot: existing?.[idx]?.timeslot ?? null,
        }));
        guestChanged = true;
      });

      if (!guestChanged) return guest;
      changed = true;
      return { ...guest, configurationGroups: configGroups };
    });

    if (changed) {
      form.setValue('guests', nextGuests as SpaPackageFormValues['guests'], {
        shouldValidate: true,
      });
    }
  }, [configGroupsNoExtras, watchedGuests, form]);
}
